import Feature30 from './Feature30'
export default Feature30
